import axios from "axios";
import { Product, CreateProductPayload } from "../types/product";
import { LoginCredentials, AuthResponse, User } from "../types/auth";

const api = axios.create({
  baseURL: "https://fakestoreapi.com",
  timeout: 10000,
});

export async function fetchProducts(): Promise<Product[]> {
  const { data } = await api.get<Product[]>("/products");
  return data;
}

export async function fetchProductById(id: number): Promise<Product> {
  const { data } = await api.get<Product>(`/products/${id}`);
  return data;
}

export async function fetchCategories(): Promise<string[]> {
  const { data } = await api.get<string[]>("/products/categories");
  return data;
}

export async function createProduct(
  product: CreateProductPayload
): Promise<Product> {
  const { data } = await api.post<Product>("/products", product);
  return data;
}

export async function login(
  credentials: LoginCredentials
): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponse>("/auth/login", credentials);
  return data;
}

export async function fetchUsers(): Promise<User[]> {
  const { data } = await api.get<User[]>("/users");
  return data;
}
